var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono facebook"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 12.1876,
    cy: 12.1876,
    r: 12.1876,
    fill: "#646363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7713 13.4926L16.15 10.7201H13.7792V8.92092C13.7792 8.16204 14.111 7.42306 15.1723 7.42306H16.25V5.06259C16.25 5.06259 15.2723 4.875 14.3364 4.875C12.3835 4.875 11.1069 6.20232 11.1069 8.60685V10.7201H8.9375V13.4926H11.1082V20.1961C11.5439 20.2728 11.9897 20.3126 12.4443 20.3126C12.899 20.3126 13.3448 20.2728 13.7804 20.1961V13.4926H15.7713Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFacebook);
export default __webpack_public_path__ + "static/media/icono-facebook.152036dc688e14ba564b4d4cf3532475.svg";
export { ForwardRef as ReactComponent };